import { HistoryIcon } from 'lucide-react';

import { Button } from '@/components/ui/button';

import { backupBannerText } from '../builder/draftCopy';

/**
 * Offers back the edits this browser kept when the builder last closed with
 * them unsaved (spec 144 FR-009).
 *
 * A banner rather than a dialog: the builder is usable behind it, showing what
 * the server holds, and the choice can wait. Nothing changes until one of the
 * two buttons is pressed — a backup applied on its own would be the builder
 * overwriting the shared draft's view with a stale copy nobody asked for.
 */
export function BuilderBackupBanner({
  savedAt,
  onRestore,
  onThrowAway,
}: {
  savedAt: string;
  onRestore: () => void;
  onThrowAway: () => void;
}) {
  return (
    <section
      aria-label="Unsaved changes on this browser"
      className="border-state-warning/30 bg-fill-warning/15 flex flex-wrap items-center gap-x-3 gap-y-2 rounded-lg border px-3 py-2 text-sm"
    >
      <HistoryIcon
        aria-hidden="true"
        className="text-state-warning size-4 shrink-0"
        strokeWidth={1.75}
      />
      <p className="text-foreground min-w-0">{backupBannerText(savedAt)}</p>
      <span className="ms-auto flex shrink-0 items-center gap-2">
        <Button variant="ghost" size="sm" onClick={onThrowAway}>
          Throw away
        </Button>
        <Button variant="outline" size="sm" onClick={onRestore}>
          Restore
        </Button>
      </span>
    </section>
  );
}
